export function addLeadingZeros(paramValue, lengtOfNumber = 2) {
  let resValue = String(paramValue);
  while (resValue.length < lengtOfNumber) {
    resValue = `0${resValue}`;
  }
  return resValue;
}

export function convertSecondToHoursMinuteSecond(paramSeconds, toString = false) {
  let second = paramSeconds;
  const hour = parseInt(second / 3600, 10);
  if (hour) {
    second %= 3600;
  }
  const minute = parseInt(second / 60, 10);
  if (minute) {
    second %= 60;
  }
  if (toString) {
    return `${addLeadingZeros(hour)}:${addLeadingZeros(minute)}:${addLeadingZeros(second)}`;
  }
  return {
    hour,
    minute,
    second,
  };
}

// #region scroll enabled and disabled
// var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

function preventDefault(e) {
  e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
  // if (keys[e.keyCode]) {
  console.log('e', e);
  preventDefault(e);
  return false;
  // }
}

// modern Chrome requires { passive: false } when adding event
let supportsPassive = false;
try {
  window.addEventListener(
    'test',
    null,
    Object.defineProperty({}, 'passive', {
      get: () => {
        supportsPassive = true;
        return null;
      },
    }),
  );
} catch (e) {
  console.log(e);
}

const wheelOpt = supportsPassive ? {passive: false} : false;
const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

export function disabledScroll(element) {
  element.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
  element.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
  element.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
  element.addEventListener('keydown', preventDefaultForScrollKeys, false);
}

export function enabledScroll(element) {
  element.removeEventListener('DOMMouseScroll', preventDefault, false); // older FF
  element.removeEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
  element.removeEventListener('touchmove', preventDefault, wheelOpt); // mobile
  element.removeEventListener('keydown', preventDefaultForScrollKeys, false);
}
// #endregion scroll enabled and disabled
